import { FC, Suspense } from 'react';
import { ExitSlipModalContainer } from './ExitSlipModalContainer';
import { ThreeDotsFullScreenLoader } from '../Fallback/ThreeDotsFullScreenLoader';

const ExitSlipModalWrapper: FC = () => {
  return (
    <Suspense fallback={<ThreeDotsFullScreenLoader />}>
      <ExitSlipModalContainer />
    </Suspense>
  );
};

export default ExitSlipModalWrapper;
